import Styled, { css } from 'styled-components';

import { VALID_FONT_WEIGHTS } from '../Typography/common';
import { cssDeclaration, normalizeColor, VALID_COLOR_DATA } from '../Utils';

export interface IInlineTextLinkProps {
  color?: VALID_COLOR_DATA;
  weight?: VALID_FONT_WEIGHTS;
}

export const InlineTextLink = Styled.a<IInlineTextLinkProps>`
  ${({ theme: { themeTwo }, color, weight }) => css`
    text-decoration: underline;
    font-weight: ${weight && weight};
    color: ${normalizeColor(themeTwo, 'link')};

    ${color && css`
      /* color */ ${color && cssDeclaration(themeTwo, 'color', color)};
    `}

    &:hover {
      ${themeTwo.link.inline.state.hover.color && cssDeclaration(themeTwo, 'color', themeTwo.link.inline.state.hover.color)};
    }
  `}
`;
